export default "__VITE_ASSET__8f6fccbe__"